import {
  Button,
  Divider,
  InputLabel,
  PasswordInput,
  Stack,
} from "@mantine/core";
import { useState } from "react";
import { useLanguage } from "../../../../stores/LanguageStore";
import { IconKey } from "@tabler/icons-react";
import PasswordField from "../../../../components/View/PasswordField";

const PasswordChanger = ({ pwdConfirm }) => {
  const lang = useLanguage((s) => s.language);
  const [clicked, setClicked] = useState(false);
  const [pwdError, setPwdError] = useState(true);

  return (
    <Stack w={"100%"} gap={"xs"}>
      {clicked ? (
        <>
          <PasswordInput
            label={lang.profile.actual_password}
            placeholder={lang.profile.actual_password}
            name="current_password"
            size="md"
            required
          />
          <PasswordField
            error={pwdError}
            setError={setPwdError}
            id={"pwd"}
            w={"100%"}
            size="md"
            label={lang.profile.new_password}
            placeholder={lang.profile.new_password}
            autoComplete="new-password"
            name="password"
            required={false}
          />
          <PasswordInput
            name="password_confirm"
            id="pwd-confirm"
            label={lang.signup.password_confirm}
            placeholder={lang.signup.password_confirm}
            w={"100%"}
            error={pwdConfirm ? lang.signup.password_confirm_error : null}
            radius={"md"}
            size="md"
          />
          <Button
            size="md"
            variant="default"
            mt={6}
            onClick={() => setClicked(false)}
          >
            {lang.global.cancel}
          </Button>
        </>
      ) : (
        <Stack gap={2} mt={10} w={"100%"}>
          {/* <InputLabel fz={12}>{lang.profile.password}</InputLabel> */}
          <Button
            variant="default"
            onClick={() => setClicked(true)}
            leftSection={<IconKey size={24} />}
            w={"100%"}
            size="lg"
          >
            {lang.profile.change_password}
          </Button>
        </Stack>
      )}
    </Stack>
  );
};

export default PasswordChanger;
